import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const GuideCard = ({ guide }) => {
  const navigate = useNavigate();
  const isTrekOfficer = !guide?.summits || guide.summits === 0;
  const roleLabel = guide?.role || (isTrekOfficer ? "Trek Officer" : "Sherpa Guide");

  return (
    <div className="bg-card rounded-2xl shadow-md hover:shadow-elevation-lg transition-all duration-300 overflow-hidden group flex flex-col">
      <div className="pt-8 pb-4 flex justify-center">
        <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-primary/10 group-hover:border-primary/30 transition-colors duration-300">
          <img
            src={guide?.image}
            alt={`${guide?.name} - ${roleLabel}`}
            className="w-full h-full object-cover"
            loading="lazy"
            onError={(e) => { e.target.src = "/assets/images/no_image.png"; }}
          />
        </div>
      </div>

      <div className="flex flex-col flex-1 px-5 pb-5 gap-3">
        <div className="text-center">
          <h3 className="text-lg font-headline font-bold text-foreground leading-tight">
            {guide?.name}
          </h3>
          <p className="text-sm text-text-secondary mt-0.5">
            {roleLabel}
          </p>
          <span className="inline-flex items-center gap-1 text-xs text-text-secondary mt-1">
            <Icon name="MapPin" size={12} />
            {guide?.village}
          </span>
        </div>

        {!isTrekOfficer && (
          <div className="flex items-center justify-center gap-2 bg-muted/40 rounded-xl px-4 py-2.5 mx-4">
            <Icon name="Mountain" size={16} className="text-primary" />
            <span className="text-lg font-bold text-primary">{guide.summits}</span>
            <span className="text-xs text-text-secondary">Successful Summits</span>
          </div>
        )}

        <div className="flex-1" />

        <Button
          variant="outline"
          fullWidth
          onClick={() => navigate(`/sherpa-guide-profiles/${guide.id}`)}
          className="group-hover:bg-primary group-hover:text-white group-hover:border-primary transition-colors duration-300 font-medium"
        >
          View Full Profile
        </Button>
      </div>
    </div>
  );
};

export default GuideCard;
